import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { LOGO_URL } from '@/lib/utils';

export default function Loader({ onComplete }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 350;
    const steps = 100;
    const interval = duration / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += 1;
      setCount(current);
      if (current >= 100) clearInterval(timer);
    }, interval);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (count >= 100) {
      const timeout = setTimeout(onComplete, 400);
      return () => clearTimeout(timeout);
    }
  }, [count, onComplete]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-obsidian flex items-center justify-center"
      exit={{ y: '-100%' }}
      transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
      data-testid="loader"
    >
      <div className="flex flex-col items-center gap-8">
        <motion.img
          src={LOGO_URL}
          alt="EB"
          className="h-16 w-auto"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
        />
        <div className="flex items-center gap-4">
          <div className="w-48 h-px bg-smoke overflow-hidden">
            <motion.div
              className="h-full bg-gold"
              initial={{ width: '0%' }}
              animate={{ width: `${count}%` }}
              transition={{ duration: 0.1 }}
            />
          </div>
          <span className="text-lg font-display text-gold tabular-nums w-12 text-right">
            {String(count).padStart(2, '0')}
          </span>
        </div>
      </div>
    </motion.div>
  );
}
